/* global jQuery COMPONENTS */
COMPONENTS.ComponentEvent = (function ($) {
  function ComponentEvent () {
    this.calendarWrap = document.getElementById('ecs-events-calender')
    this.$calendar = $(this.calendarWrap)
    this.listWrap = document.getElementById('ecs-events-list')
    this.listBody = document.getElementById('ecs-events-list-body')
    this.scrollUpBtn = document.getElementById('ecs-events-list-scroll-up')
    this.ec = null
    this.currentMonthIndex = 0
    this.monthKeys = []
  }

  ComponentEvent.prototype.init = function () {
    const self = this
    const viewportTablet = window.matchMedia('(min-width: 768px)')

    if (!$('#ecs-events-calender').length) return

    // Initialise the EventCalendar library for dayGridMonth only
    self.ec = EventCalendar.create(document.getElementById('ecs-events-calender'), {
      view: 'dayGridMonth',
      headerToolbar: { start: 'prev', center: 'title', end: 'today next' },
      events: events,
      editable: false,
      eventStartEditable: false,
      eventDurationEditable: false,
      eventClick: function (info) {
        if (!viewportTablet.matches) {
          let $eventCard = $('#' + info.event.id)
          $eventCard[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
          $('.ec-day').removeClass('ecs_active')
          $('.ecs_event_mini_card').removeClass('ecs_active')
          $(info.el).parent().parent().addClass('ecs_active')
          $eventCard.addClass('ecs_active')
        } else {
          let baseURL = window.location.origin + window.location.pathname
        window.location.href = baseURL + info.event.id + '?view=calendar'
        }
      }
    })

    // Prepare custom list view (collect months, determine start month)
    self.initListView()

    // View toggle
    const $viewToggle = $('.ecs_event_view_toggle__btn')
    if ($viewToggle.length) {
      $viewToggle.on('click', function () {
        const view = $(this).data('view')
        $viewToggle.removeClass('is-active').attr('aria-pressed', 'false')
        $(this).addClass('is-active').attr('aria-pressed', 'true')

        if (view === 'listMonth') {
          // Switch to custom list
          $(self.calendarWrap).hide()
          if (self.listWrap) self.listWrap.removeAttribute('hidden')
          $('#ecs-events-calender-cards').addClass('ecs_event_calendar_cards--hidden')
          // Defer scroll-to-today until the element is visible in the DOM
          requestAnimationFrame(function () {
            self.showMonth(self.currentMonthIndex, true)
          })
          self.setViewParam('list')
        } else {
          // Switch to EC calendar
          $(self.calendarWrap).show()
          if (self.listWrap) self.listWrap.setAttribute('hidden', true)
          $('#ecs-events-calender-cards').toggleClass('ecs_event_calendar_cards--hidden', view !== 'dayGridMonth')
          self.ec.setOption('view', view)
          self.setViewParam('calendar')
        }
      })

      // Restore view from URL param (e.g. when returning from a single event page)
      const urlParams = new URLSearchParams(window.location.search)
      const savedView = urlParams.get('view')
      if (savedView === 'list') {
        $viewToggle.filter('[data-view="listMonth"]').trigger('click')
      } else {
        // Default: calendar view — seed card links so they carry ?view=calendar
        self.updateCardLinks('calendar')
      }
    }
  }

  /**
   * Collect all month keys from the DOM and wire up navigation and scroll events.
   * Called once during init; does not scroll (list is hidden at this point).
   */
  ComponentEvent.prototype.initListView = function () {
    const self = this

    console.log('Initializing list view')

    if (!self.listWrap) return

    // Collect months in document order
    self.monthKeys = []
    $('.ecs_event_list_month').each(function () {
      self.monthKeys.push($(this).data('month'))
    })

    if (!self.monthKeys.length) return

    // Determine starting month: prefer current calendar month, else first future month
    const today = new Date()
    const todayMonthKey = self.getMonthKey(today)
    let startIndex = self.monthKeys.indexOf(todayMonthKey)

    if (startIndex === -1) {
      startIndex = 0
      for (let i = 0; i < self.monthKeys.length; i++) {
        if (self.monthKeys[i] >= todayMonthKey) {
          startIndex = i
          break
        }
      }
    }

    self.currentMonthIndex = startIndex

    // Prev / Next navigation
    $('.ecs_event_list_prev').on('click', function () {
      if (self.currentMonthIndex > 0) {
        self.currentMonthIndex--
        self.showMonth(self.currentMonthIndex, true)
      }
    })

    $('.ecs_event_list_next').on('click', function () {
      if (self.currentMonthIndex < self.monthKeys.length - 1) {
        self.currentMonthIndex++
        self.showMonth(self.currentMonthIndex, true)
      }
    })

    // Scroll-up button: show when the body has been scrolled away from the top
    if (self.listBody && self.scrollUpBtn) {
      self.listBody.addEventListener('scroll', function () {
        if (self.listBody.scrollTop > 10) {
          self.scrollUpBtn.classList.add('is-visible')
        } else {
          self.scrollUpBtn.classList.remove('is-visible')
        }
      })

      self.scrollUpBtn.addEventListener('click', function () {
        self.listBody.scrollTo({ top: 0, behavior: 'smooth' })
      })
    }
  }

  /**
   * Show the month at the given index.
   *
   * @param {number}  index             Index into this.monthKeys.
   * @param {boolean} shouldScrollToday When true and the month is the current
   *                                    calendar month, scroll to the first
   *                                    today-or-future event.
   */
  ComponentEvent.prototype.showMonth = function (index, shouldScrollToday) {
    const self = this
    const monthKey = self.monthKeys[index]

    // Hide all months then reveal the target
    $('.ecs_event_list_month').attr('hidden', true)
    const $month = $('.ecs_event_list_month[data-month="' + monthKey + '"]')
    $month.removeAttr('hidden')

    // Update toolbar title
    const label = $month.data('label') || monthKey
    $('.ecs_event_list_title').text(label)

    // Disable nav buttons at boundaries
    $('.ecs_event_list_prev').prop('disabled', index === 0)
    $('.ecs_event_list_next').prop('disabled', index === self.monthKeys.length - 1)

    // Reset scroll and hide the scroll-up indicator
    if (self.listBody) self.listBody.scrollTop = 0
    if (self.scrollUpBtn) self.scrollUpBtn.classList.remove('is-visible')

    // Optionally scroll to today (only meaningful for the current month)
    if (shouldScrollToday && monthKey === self.getMonthKey(new Date())) {
      self.scrollToToday()
    }
  }

  /**
   * Scroll the list body so that the first event on or after today is at the
   * top of the visible area.
   */
  ComponentEvent.prototype.scrollToToday = function () {
    const self = this
    if (!self.listBody) return

    const today = new Date()
    const todayStr = self.getDateKey(today)

    let targetEl = null
    $('.ecs_event_list_month:not([hidden]) .ecs_event_list_row').each(function () {
      if (!targetEl && $(this).data('date') >= todayStr) {
        targetEl = this
      }
    })

    if (targetEl) {
      // Anchor to the day group so the date header is visible at the top
      const anchorEl = targetEl.closest('.ecs_event_list_day') || targetEl
      const bodyRect = self.listBody.getBoundingClientRect()
      const anchorRect = anchorEl.getBoundingClientRect()
      const scrollOffset = self.listBody.scrollTop + (anchorRect.top - bodyRect.top)
      self.listBody.scrollTop = Math.max(0, scrollOffset)
    }
  }

  /** Updates the ?view= URL param without triggering a page reload. */
  ComponentEvent.prototype.setViewParam = function (view) {
    const url = new URL(window.location.href)
    url.searchParams.set('view', view)
    history.replaceState(null, '', url.toString())
    this.updateCardLinks(view)
  }

  /**
   * Updates all ecs_event_card_link hrefs to carry the current view param
   * so that navigating from a card always returns to the correct view.
   *
   * @param {string} view 'calendar' or 'list'
   */
  ComponentEvent.prototype.updateCardLinks = function (view) {
    $('.ecs_event_card_link').each(function () {
      const linkUrl = new URL(this.href, window.location.origin)
      linkUrl.searchParams.set('view', view)
      this.href = linkUrl.toString()
    })
  }

  /** Returns 'YYYY-MM' for a Date object. */
  ComponentEvent.prototype.getMonthKey = function (date) {
    return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0')
  }

  /** Returns 'YYYY-MM-DD' for a Date object. */
  ComponentEvent.prototype.getDateKey = function (date) {
    return (
      date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0')
    )
  }

  return ComponentEvent
})(jQuery)

COMPONENTS.componentEvent = COMPONENTS.ComponentEvent

document.addEventListener('components_init', function (e) {
  if (!(COMPONENTS.componentEventInstance instanceof COMPONENTS.ComponentEvent)) {
    COMPONENTS.componentEventInstance = new COMPONENTS.ComponentEvent()
  }
  COMPONENTS.componentEventInstance.init()
})
